// extracted by mini-css-extract-plugin
export default {"modal":"modal__w4d5s"};